import BaseService from "./base.service";


class UserService extends BaseService {

    constructor(clientType: 'axios' | 'fetch' = 'axios') {
        super(clientType);
    }

    getInfo = async () => {
        return await this.get('/user/info')
    }

    getTestUser = async () => {
        return await this.post('/user/test-user', {})
    }

    updateInfo = async (name: string, phoneNumber: string) => {
        return await this.post('/user/update-info', {name, phoneNumber})
    }

    updatePassword = async (email: string, password: string, newPassword: string) => {
        return await this.post('/user/update-password', {email, password, newPassword})
    }
}

export default UserService